import { compose } from '@reduxjs/toolkit';
import { withFormPlayer } from '../../edit/Form/Player';
import SuggestedThumbnails from './SuggestedThumbnails';

const enhance = compose(withFormPlayer);
export default enhance(SuggestedThumbnails);
